import { ReactComponent as ClassIcon } from '../assets/icons/class.svg'
import { ReactComponent as HomeIcon } from '../assets/icons/home.svg'
import { ReactComponent as DeviceIcon } from '../assets/icons/device.svg'
import { ReactComponent as FileJPG } from '../assets/icons/file-jpg.svg'
import { ReactComponent as FilePDF } from '../assets/icons/file-pdf.svg'
import { ReactComponent as FilePNG } from '../assets/icons/file-png.svg'
import { ReactComponent as FilePPT } from '../assets/icons/file-ppt.svg'
import image1 from '../assets/images/board-image.png'
// import { ReactComponent as DataIcon } from '../assets/icons/data.svg'

export const menuList = [
  {
    title: '메인',
    icon: () => <ClassIcon />,
    path: '/',
  },
  {
    title: '수업관리',
    icon: () => <HomeIcon />,
    path: '/class',
  },
  // {
  //   title: '자료실',
  //   icon: () => <DataIcon />,
  //   path: '/data',
  // },
  {
    title: '기기관리',
    icon: () => <DeviceIcon />,
    path: '/device',
  },
]

// export const tabList = [
//   {
//     name: '수업 차시',
//     key: 'lesson',
//     component: () => <ClassLessonTab editState={isLessonEdit} onStateChange={handleEditState} />,
//     null: () => <ClassDetailNull />,
//     data: classLessonList,
//   },
//   {
//     name: '수강 학생 관리',
//     key: 'student',
//     data: classStudentList,
//     component: () => <ClassStudentTab />,
//     null: () => <ClassStudentNull />,
//   },
//   {
//     name: '과목 자료실',
//     key: 'data',
//     component: () => <ClassDataTab />,
//     null: () => <ClassDataNull />,
//     data: classDataList,
//   },
// ]

export const semesterList = {
  nowSemester: {
    name: '2024년 1학기',
  },
  semesters: [
    {
      name: '2023년 1학기',
    },
    {
      name: '2023년 1학기',
    },
    {
      name: '2023년 1학기',
    },
  ],
}

export const classLessonList = [
  {
    week: '0주차',
    classes: [
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: true,
      },
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: true,
      },
    ],
  },
  {
    week: '0주차',
    classes: [
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: true,
      },
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: true,
      },
    ],
  },
  {
    week: '1주차',
    classes: [
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: true,
      },
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: true,
      },
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: true,
      },
    ],
  },
  {
    week: '2주차',
    classes: [
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: true,
      },
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: true,
      },
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: true,
      },
    ],
  },
  {
    week: '3주차',
    classes: [
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: false,
      },
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: false,
      },
      {
        nth: '1차시',
        date: '8월 3일',
        day: '월요일',
        time: '1교시',
        title: '설명이 있는 경우 이렇게 표시 됩니다',
        status: false,
      },
    ],
  },
]

export const classDataList = [
  {
    name: '5세대 이동통신 기술 6G 상용화,초고속 인터넷 시대 개막.jpg',
    favorites: true,
    createdAt: '2000.00.00',
  },
  {
    name: '역대급 인공지능 슈퍼컴퓨터 개발,과학 기술 혁신 촉진.pdf',
    favorites: false,
    createdAt: '2000.00.00',
  },
  {
    name: '무인 택배 드론 서비스,시험 운영 중으로 곧 상용화 예정.png',
    favorites: true,
    createdAt: '2000.00.00',
  },
  { name: '자료명' },
]

export const classStudentList = [
  { studentId: '1학년 1반 1번', name: '강다니엘', major: '경영사무과', createdAt: '2000.00.00' },
  { studentId: '1학년 1반 2번', name: '강다니엘', major: '경영사무과', createdAt: '2000.00.00' },
  { studentId: '1학년 1반 3번', name: '강다니엘', major: '경영사무과', createdAt: '2000.00.00' },
]

export const dayEnumList = {
  MONDAY: '월요일',
  TUESDAY: '화요일',
  WEDNESDAY: '수요일',
  THURSDAY: '목요일',
  FRIDAY: '금요일',
  SATURDAY: '토요일',
  SUNDAY: '일요일',
}
export const fileTypeList = {
  PDF: <FilePDF className='h-full w-full' />,
  JPG: <FileJPG className='h-full w-full' />,
  PNG: <FilePNG className='h-full w-full' />,
  JPEG: <FileJPG className='h-full w-full' />,
  PPT: <FilePPT className='h-full w-full' />,
  PPTX: <FilePPT className='h-full w-full' />,
}

export const slideList = [
  { id: 1, image: image1 },
  { id: 2, image: image1 },
  { id: 3, image: image1 },
  { id: 4, image: image1 },
  { id: 4, image: image1 },
  { id: 4, image: image1 },
  { id: 4, image: image1 },
  { id: 4, image: image1 },
  { id: 4, image: image1 },
]

export const statusList = {
  UPCOMING: { text: '수업 준비', color: '#FF4242' },
  ONGOING: { text: '수업 진행중', color: '#13BD7E' },
  COMPLETED: { text: '수업 종료', color: '#C2C4C8' },
}
